import request from '@/utils/request'

/** 根据`noticeTag`分页查询列表 */
export const getNoticeList = (query: {
  /** 查询的标签类型。以`,`分割 */
  noticeTags: string
}) => {
  return request<{ rows: NoticeItem[] }>({
    url: `/web/notice/list`,
    method: 'get',
    params: {
      /** 已发布的 */
      publishStatus: 2,
      ...query,
    },
  })
}

/** 根据`noticeTag`分页查询热点文章列表 */
export const getHotList = (query: {
  /** 查询的标签类型。以`,`分割 */
  noticeTags: string
}) => {
  return request<{ rows: NoticeItem[] }>({
    url: `/web/notice/listHotArticles`,
    method: 'get',
    params: query,
  })
}

/** 获取文章下的详情 */
export const getNoticeDetail = (id: string) => {
  return request<{
    data: NoticeItem
  }>({
    url: `/web/notice/${id}`,
    method: 'get',
  })
}
